import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=4664be49&scoped=true&"
import script from "./Platforms.vue?vue&type=script&lang=ts&"
export * from "./Platforms.vue?vue&type=script&lang=ts&"
import style0 from "./Platforms.vue?vue&type=style&index=0&id=4664be49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664be49",
  null
  
)

export default component.exports